import { Routes, Route } from "react-router-dom";
import Sidebar from "@/components/dashboard/Sidebar";
import { ServerProvider } from "@/lib/server-context";

import Overview from "@/components/dashboard/Overview";
import MusicPanel from "@/components/dashboard/MusicPanel";
import ChannelsPanel from "@/components/dashboard/ChannelsPanel";
import MembersPanel from "@/components/dashboard/MembersPanel";
import GeminiChat from "@/components/dashboard/GeminiChat";
import SettingsPanel from "@/components/dashboard/SettingsPanel";
import PricingPanel from "@/components/dashboard/PricingPanel";
import AdminPanel from "@/components/dashboard/AdminPanel";

import LeaderboardPanel from "@/components/dashboard/features/LeaderboardPanel";
import PersonalizerPanel from "@/components/dashboard/features/PersonalizerPanel";
import WelcomePanel from "@/components/dashboard/features/WelcomePanel";
import ReactionRolesPanel from "@/components/dashboard/features/ReactionRolesPanel";
import LevelsPanel from "@/components/dashboard/features/LevelsPanel";
import CustomCommandsPanel from "@/components/dashboard/features/CustomCommandsPanel";
import GiveawaysPanel from "@/components/dashboard/features/GiveawaysPanel";
import PollsPanel from "@/components/dashboard/features/PollsPanel";
import BirthdaysPanel from "@/components/dashboard/features/BirthdaysPanel";
import EconomyPanel from "@/components/dashboard/features/EconomyPanel";
import RemindersPanel from "@/components/dashboard/features/RemindersPanel";
import EmbedMessagesPanel from "@/components/dashboard/features/EmbedMessagesPanel";
import InviteTrackerPanel from "@/components/dashboard/features/InviteTrackerPanel";
import StatsChannelsPanel from "@/components/dashboard/features/StatsChannelsPanel";
import TempChannelsPanel from "@/components/dashboard/features/TempChannelsPanel";
import HelpPanel from "@/components/dashboard/features/HelpPanel";
import ComingSoon from "@/components/dashboard/ComingSoon";

const SOON = [
  ["ai-characters", "AI Characters", "Custom AI personalities — chat with the bot as different characters."],
  ["emojis", "Emoji Manager", "Bulk-import, organize, and animate emojis across servers."],
  ["achievements", "Achievements", "Unlock badges by hitting milestones (messages, voice hours, etc)."],
  ["starboards", "Starboards", "Pin community-favorite messages by ⭐ reactions."],
  ["automations", "Automations", "If-this-then-that workflows for moderation and auto-responses."],
  ["ticketing", "Ticketing", "Self-service support tickets with private threads."],
  ["search", "Search Anything", "Cross-platform search inside Discord (web, images, GIFs)."],
  ["twitch-alerts", "Twitch Alerts", "Notify channel when streamers go live."],
  ["tiktok-alerts", "TikTok Alerts", "TikTok video drops in your channel."],
  ["x-alerts", "X Alerts", "Track tweets from chosen accounts."],
  ["bluesky-alerts", "Bluesky Alerts", "Bluesky post tracking."],
  ["youtube-alerts", "YouTube Alerts", "Notify on new uploads."],
  ["reddit-alerts", "Reddit Alerts", "New posts from subreddits."],
  ["instagram-alerts", "Instagram Alerts", "Instagram post notifications."],
  ["rss-feeds", "RSS Feeds", "Watch any RSS feed for updates."],
  ["kick-alerts", "Kick Alerts", "Kick.com livestream alerts."],
  ["podcast-alerts", "Podcast Alerts", "New episode notifications."],
  ["monetize", "Monetize", "Server-level monetization tools."],
  ["sponsorships", "Sponsorships", "Manage sponsor deals natively."],
  ["web3-sub", "Web3 Subscription", "On-chain subscription verification."],
  ["web3-stats", "Web3 Statistics", "Wallet & on-chain analytics."],
  ["nft-queries", "NFT Queries", "Lookup NFT metadata in chat."],
  ["nft-sales", "NFT Sales & Listing", "Marketplace listings and sale alerts."],
  ["crypto-stats", "Crypto Statistics", "Live token prices in your channels."],
  ["crypto-queries", "Crypto Queries", "Lookup token data in chat."],
  ["gas-tracker", "Gas Tracker", "Live ETH/BNB gas prices."],
  ["gating", "Token Gating", "Hold-to-access roles by token/NFT."],
];

export default function Dashboard() {
  return (
    <ServerProvider>
      <div data-testid="dashboard-root" className="min-h-screen bg-black text-white flex">
        <Sidebar />
        <main className="flex-1 min-w-0 p-6 md:p-10 tactical-grid-fine overflow-x-hidden">
          <Routes>
            <Route index element={<Overview />} />
            <Route path="music" element={<MusicPanel />} />
            <Route path="channels" element={<ChannelsPanel />} />
            <Route path="members" element={<MembersPanel />} />
            <Route path="moderator" element={<MembersPanel />} />
            <Route path="ai" element={<GeminiChat />} />
            <Route path="settings" element={<SettingsPanel />} />
            <Route path="pricing" element={<PricingPanel />} />
            <Route path="admin" element={<AdminPanel />} />

            <Route path="leaderboard" element={<LeaderboardPanel />} />
            <Route path="personalizer" element={<PersonalizerPanel />} />
            <Route path="welcome" element={<WelcomePanel />} />
            <Route path="welcome-channel" element={<WelcomePanel />} />
            <Route path="reaction-roles" element={<ReactionRolesPanel />} />
            <Route path="levels" element={<LevelsPanel />} />
            <Route path="custom-commands" element={<CustomCommandsPanel />} />
            <Route path="giveaways" element={<GiveawaysPanel />} />
            <Route path="polls" element={<PollsPanel />} />
            <Route path="birthdays" element={<BirthdaysPanel />} />
            <Route path="economy" element={<EconomyPanel />} />
            <Route path="reminders" element={<RemindersPanel />} />
            <Route path="embed-messages" element={<EmbedMessagesPanel />} />
            <Route path="invite-tracker" element={<InviteTrackerPanel />} />
            <Route path="stats-channels" element={<StatsChannelsPanel />} />
            <Route path="temp-channels" element={<TempChannelsPanel />} />
            <Route path="help" element={<HelpPanel />} />

            {SOON.map(([slug, title, desc]) => (
              <Route key={slug} path={slug} element={<ComingSoon title={title} description={desc} />} />
            ))}
          </Routes>
        </main>
      </div>
    </ServerProvider>
  );
}
